import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CONTAINER_SIZES } from '../../../contants/CONTAINER_SIZES';
import { AlertService } from '../../../services/alert.service';
import { ParameterService } from '../../../services/parameter.service';

@Component({
	selector: 'ztsi-container-size-select',
	templateUrl: './ztsi-container-size-select.component.html',
	styleUrls: ['./ztsi-container-size-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiContainerSizeSelectComponent),
			multi: true
		}
	]
})
export class ZtsiContainerSizeSelectComponent implements ControlValueAccessor {
	containerSizes: string[] = CONTAINER_SIZES;

	constructor(
		private _parameterService: ParameterService,
		private _alertService: AlertService
	) { }

	@Input() isDisabled: boolean = false;
	@Input('value') _value: string;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._parameterService.getCachedSystemParameterArray<string>('CONTAINER_SIZES', 3600).subscribe(response => {
			if (response.length != undefined) {
				if (response.length != 0) {
					this.containerSizes = response;
				}
			}
			else {
				console.log('Unable to load container size selection.');
			}

			if (this.value === null && this.containerSizes.length > 0) {
				this.value = this.containerSizes[0];
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-container-size-select/ztsi-container-size-select.component.ts